import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Button } from "@material-tailwind/react";
import events from "./articleEvent";
import ModalEvent from "./ModalEvent";
import kidsDesktop from "/assets/images/kids-fun.webp";

export const Evenement = () => {
  const [expandedEvent, setExpandedEvent] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
  document.title = "Événements - École L'Olivier";

  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute(
      "content",
      "Découvrez tous les événements extra-scolaires de l'école L'Olivier à Marseille, gala, ateliers, sorties et activités pour nos élèves."
    );
  } else {
    const metaTag = document.createElement("meta");
    metaTag.name = "description";
    metaTag.content =
      "Découvrez tous les événements extra-scolaires de l'école L'Olivier à Marseille, gala, ateliers, sorties et activités pour nos élèves.";
    document.head.appendChild(metaTag);
  }
}, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 720);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const img = new Image();
    img.src = kidsDesktop;
    img.onload = () => setImageLoaded(true);
  }, []);

  return (
    <main className="bg-white text-black">
      {/* Header */}
      <header className="relative h-[50vh] overflow-hidden bg-[#8f9324]">
        <img
          src={kidsDesktop}
          alt="Enfants qui s'amusent à l'école"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
        />
        <div className="absolute inset-0 bg-black/50"></div>

        <motion.div
          className="absolute inset-0 flex flex-col gap-6 justify-center items-center text-white text-center p-4 z-10"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h1 className="text-4xl sm:text-5xl font-bold">
            Événements de l'école
          </h1>
          <p className="text-xl italic max-w-2xl">
            Découvrez nos évenements extra-scolaire avec l'école l'Olivier
          </p>
        </motion.div>
      </header>

      {/* Liste des événements */}
      <section
        id="contenu"
        className="w-full flex flex-col md:flex-row md:flex-wrap justify-center items-center md:items-stretch py-10 px-4 gap-8"
      >
        {events.map((event) => (
          <motion.article
            key={event.id}
            className="relative flex flex-col bg-[#e9ebc4] p-6 rounded-2xl shadow-lg border border-[#8f9324] transition-transform transform hover:scale-105 max-w-96 "
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {event.isLimited && (
              <span className="absolute top-3 left-3 bg-red-600 text-white text-xs px-3 py-1 rounded-full font-medium">
                Places limitées
              </span>
            )}
            <img
              src={isMobile ? event.imageMobile : event.imageDesktop}
              alt={event.alt}
              className="w-full h-80 object-cover object-top rounded-md border border-[#8f9324]"
              loading="lazy"
            />
            <div className="mt-4 flex-1 flex flex-col justify-between gap-3">
              <h2 className="text-2xl font-semibold text-vertLogo">
                {event.title}
              </h2>
              <motion.div
                className="text-black"
                initial={{ maxHeight: 100 }}
                animate={{ maxHeight: expandedEvent === event.id ? 300 : 100 }}
                transition={{ duration: 0.3 }}
              >
                {expandedEvent === event.id ? event.longDesc : event.shortDesc}
              </motion.div>

              <div className="flex flex-wrap gap-3 items-center justify-between w-full mt-3  border-red-600">
                <p className="flex gap-2 items-center text-sm text-gray-700">
                  📅 {event.date}
                </p>
                {event.isActive && (
                  <button
                    className=" bg-vertLogo text-white px-4 py-2 rounded-md shadow-lg shadow-vertLogo hover:scale-105 transition-all ease-linear"
                    variant="outline"
                    aria-label="bouton voir plus"
                    tabIndex={-1}
                    onClick={() => {
                      if (event.isModal) {
                        setSelectedEvent(event);
                      }
                    }}
                  >
                    <span>Voir plus</span>
                  </button>
                )}
                {event.isLink && (
                  <a href={event.link} className=" underline">
                    {event.contenuLink}
                  </a>
                )}
              </div>
            </div>
          </motion.article>
        ))}
      </section>
      {selectedEvent && (
        <ModalEvent event={selectedEvent} setSelectedEvent={setSelectedEvent} />
      )}
    </main>
  );
};
